module.exports = __webpack_public_path__ + "static/media/70s2.678b30f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/trends/_old/70s2.jpg
// module id = 353
// module chunks = 0